import { render, staticRenderFns } from "./FormListActions.vue?vue&type=template&id=445330f7&scoped=true"
import script from "./FormListActions.vue?vue&type=script&setup=true&lang=js"
export * from "./FormListActions.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormListActions.vue?vue&type=style&index=0&id=445330f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445330f7",
  null
  
)

export default component.exports